<section class="popup">
  <div class="main-banner">
    @if(data.icon){
      <img [src]="data.icon" alt="" class="page-icon" />
    }
    @if(data.title){
      <h2>{{data.title}}</h2>
    }
    <p class="info-text" [innerHtml]="data.text">
    </p>
  </div>
  <div class="button-wrapper">
    <button u1-button class="default-button aqua no-border" title="" id="button" (click)="buttonClick()" (keydown.space)="$event.preventDefault()">{{data.buttonName}}</button>
  </div>
  @if(data.linkName){
    <div class="link-wrapper">
      <a class="default-link"
         u1-link
         title=""
         id="link"
         (click)="linkClick()"
         >{{data.linkName}}</a>
    </div>
  }
  <span class="close-popup"
        u1-button
        aria-label="Close"
        (click)="dismiss()"
        ></span>
  @if(data.asterisks){
    <div class="info-text" [innerHtml]="data.asterisks">
    </div>
  }
</section>
